import React, { Fragment, useContext } from 'react';
import {
  CadNarrativeValueType,
  CadPersonValueType
} from '../../../../../../Models/CadReportValue';
import { FieldItemList } from '../../../CommonBody/FieldItemList/FieldItemList';
import { FieldValueType } from '../../../../../../Models';
import { getCADPersonnelFullName } from '../../../CommonBody/Helpers';
import { formatDate } from '../../../../../../Helpers';
import { Customer, CustomerContext } from 'ui-smartforce-settings';

const getNarrativeAuthorLabel = (
  narrative: CadNarrativeValueType,
  personnel: CadPersonValueType[],
  timezone: string
): string => {
  const authorBadgeId = narrative['badge_id'] as string;
  const authorName = getCADPersonnelFullName(authorBadgeId, personnel);

  return `${formatDate(narrative.date_time, 'L - HH:mm', timezone)} - ${authorName}`;
};

const getNarrativeFields = (
  narrative: CadNarrativeValueType,
  personnel: CadPersonValueType[],
  timezone: string
) => {
  let fields = [
    {
      label: getNarrativeAuthorLabel(narrative, personnel, timezone),
      value: narrative['narrative'] as FieldValueType,
      type: 'string'
    }
  ];

  return fields;
};

export interface CadNarrativesInformationProps {
  narratives: CadNarrativeValueType[];
  personnel: CadPersonValueType[];
}

export const CadNarrativesInformation = ({
  narratives,
  personnel
}: CadNarrativesInformationProps): React.ReactElement<CadNarrativesInformationProps> => {
  const timezone = (useContext(CustomerContext).customer as Customer).timezone;
  return (
    <Fragment>
      {narratives.map((narrative, index) => (
        <FieldItemList
          key={`${narrative.date_time}-${index}`}
          title={`${index === 0 ? 'Narratives' : ''}`}
          fields={getNarrativeFields(narrative, personnel, timezone)}
          hasDivider={index < narratives.length - 1}
        />
      ))}
    </Fragment>
  );
};
